module.exports = {
	"id": "TV",
	"name": "Tuvalu",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.065568,
			"33": null,
			"34": null,
			"35": 0.24588,
			"36": null,
			"37": null,
			"38": null,
			"39": 0.12294,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": null,
			"48": 1.31136,
			"49": 0.434388,
			"50": null,
			"51": 1.122852,
			"52": 1.934256,
			"53": 29.964576,
			"54": 8.548428,
			"55": 0.065568,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.565524,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.065568,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": 0.065568,
			"46": null,
			"47": 1.499868,
			"48": 2.311272,
			"49": 23.096328,
			"50": 0.499956,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.065568,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.499956,
			"10": 0.188508,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": 0.24588,
			"7.1": null,
			"9.1": 0.377016
		},
		"ios_saf": {
			"8": 0,
			"10": 0.439022401332,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0118311457119,
			"8.1-8.4": 0.021857540383,
			"9.0-9.2": 0.010427450458,
			"9.3": 0.159085462115
		},
		"android": {
			"3": 0,
			"4": 0.220549488372,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0275686860465,
			"4.1": 0.795553511628,
			"4.2-4.3": 1.98888377907,
			"4.4": 4.56064834884,
			"4.4.3-4.4.4": 4.60003218605
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.314967186441,
			"9": null,
			"10": 0.124329152542,
			"11": 5.36273077966,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00982828034814,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000273007787448
		},
		"edge": {
			"12": 0.934344,
			"13": null,
			"14": 0.065568
		},
		"ie_mob": {
			"10": 0.0142287323944,
			"11": 0.0579312676056
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 0.07216
		},
		"and_uc": {
			"0": null
		},
		"op_mini": {
			"0": 0.132414711864
		},
		"and_chr": {
			"0": 4.455356
		},
		"and_ff": {
			"0": 0.214676
		}
	},
	"total": 97.8910951186
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TV.json
 ** module id = 667
 ** module chunks = 0
 **/